import { DefaultOptions, Environment } from "./base-environment";

export const environment: Environment = {
  ...DefaultOptions,
  scope: 'luca',
  port: undefined,
  forceScope: true,
  efact_enviroment:"qa",
  url: 'https://testback.innovangels.com',
};